import React, { useEffect, useState, useMemo } from "react";
import EditableTable from "../../../../../../components/Tables/EditableTable";
import { FabInitialData, fabricationColumns } from "./utils";
import { useParams } from "react-router-dom";
import {
  createFabrication,
  deleteFabrication,
  getFabrication,
  getFabricationByPlant,
  updateFabrication,
} from "./api";
import { secondAxios } from "../../../../../../api/axios";
import TimesheetDialog from "../../../../../../components/Dialogs/TimesheetDialog";
import {
  deleteTimesheet,
  updateTimesheet,
  createTimesheet,
  getTimesheets,
} from "./timesheetAPI";
import { useMsal } from "@azure/msal-react";
import { usePCS } from "../PCSContext";
import PlantTasksWrapper from "../../../../Project/plant/PlantTaskPage/PlantTasksWrapper";
const calculateActualHours = (item) => {
  if (
    item?.timesheets &&
    Array.isArray(item.timesheets) &&
    item.timesheets.length > 0
  ) {
    return item.timesheets.reduce(
      (sum, ts) => sum + (Number(ts.hours) || 0),
      0,
    );
  }
  return 0;
};

const FabricationTab = ({ plant = false, projectFilter = [] }) => {
  const { id, plantId } = useParams();
  const {
    fabricationData,
    plantId: contextPlantId,
    refreshPlantData,
    SrvOptions,
    selectedSrvs,
  } = usePCS();
  const [users, setUsers] = useState([]);
  const user = useMsal().accounts[0];
  const [timesheetDialogState, setTimesheetDialogState] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  // Use plantId from params or context
  const activePlantId = plantId || contextPlantId;

  const openTimesheet = (selectedItem) => {
    console.log("selectedItem", selectedItem);
    setSelectedItem(selectedItem);
    setTimesheetDialogState(true);
  };

  useEffect(() => {
    const getAllUsers = async () => {
      const users = (await secondAxios.get("/user")).data;
      const usernames = users.map((u) => u.name);
      setUsers(usernames);
      console.log("users", users);
    };
    getAllUsers();
  }, []);

  // Custom getItems function that uses plant endpoint when in plant mode
  const getItems = () => {
    console.log("srv materialsss init");

    let materials = [];
    selectedSrvs?.forEach((s) => {
      console.log("srv materialsss", s);
      const srv = SrvOptions.find((o) => o.srvNumber === s);

      srv.srvMaterials?.forEach((m) => {
        console.log("srv materials", m);
        materials.push(m.material);
      });
    });
    return materials;
    // if (plant && activePlantId) {
    //   // Use plant-specific endpoint to fetch fabrications
    //   return async (parentId) => {
    //     const data = await getFabricationByPlant(activePlantId);

    //     // Transform data to calculate actualhours from timesheets
    //     const transformedData = data.map((item) => ({
    //       ...item,
    //       actualhours: calculateActualHours(item),
    //     }));

    //     // Apply project filter if projects are selected
    //     if (Array.isArray(projectFilter) && projectFilter.length > 0) {
    //       const normalizedFilters = projectFilter.map((f) => String(f));
    //       return transformedData.filter((item) => {
    //         const idMatch =
    //           item?.projectId !== undefined &&
    //           normalizedFilters.includes(String(item.projectId));
    //         const nameMatch =
    //           item?.projectName &&
    //           normalizedFilters.some(
    //             (filter) => item.projectName.toLowerCase() === filter.toLowerCase()
    //           );
    //         return idMatch || nameMatch;
    //       });
    //     }

    //     return transformedData;
    //   };
    // }
    // // Also transform data for project mode
    // return async (parentId) => {
    //   const data = await getFabrication(parentId);
    //   return data.map((item) => ({
    //     ...item,
    //     actualhours: calculateActualHours(item),
    //   }));
    // };
  };

  // Wrapper for createItem that handles plant mode
  const handleCreateFabrication = useMemo(() => {
    if (plant && activePlantId) {
      return async (parentId, fabrication) => {
        await createFabrication(activePlantId, fabrication, true);
        // Refresh plant data after creation
        if (refreshPlantData) {
          refreshPlantData();
        }
      };
    }
    return createFabrication;
  }, [plant, activePlantId, refreshPlantData]);

  // Wrapper for updateItem that refreshes plant data
  const handleUpdateFabrication = useMemo(() => {
    if (plant && refreshPlantData) {
      return async (fabrication) => {
        await updateFabrication(fabrication);
        refreshPlantData();
      };
    }
    return updateFabrication;
  }, [plant, refreshPlantData]);

  // Wrapper for deleteItem that refreshes plant data
  const handleDeleteFabrication = useMemo(() => {
    if (plant && refreshPlantData) {
      return async (fabricationId) => {
        await deleteFabrication(fabricationId);
        refreshPlantData();
      };
    }
    return deleteFabrication;
  }, [plant, refreshPlantData]);

  return (
    <div>
      {plant ? (
        <PlantTasksWrapper type="fabrication" materials={getItems()} />
      ) : (
        <>
          <EditableTable
            name="Fabrication"
            displayMode="row"
            columns={fabricationColumns(users, openTimesheet)}
            enableEditing={true}
            enableCreate={true}
            initialData={FabInitialData}
            api={{
              getItems: getItems,
              createItem: handleCreateFabrication,
              updateItem: handleUpdateFabrication,
              deleteItem: handleDeleteFabrication,
            }}
            parentId={plant ? activePlantId : id}
          />
          <TimesheetDialog
            open={timesheetDialogState}
            handleClose={() => {
              setTimesheetDialogState(false);
            }}
            parentId={selectedItem?.id}
            parentName={selectedItem?.document}
            api={{
              getItems: getTimesheets,
              createItem: createTimesheet.bind(null, user?.username),
              updateItem: updateTimesheet,
              deleteItem: deleteTimesheet,
            }}
          />
        </>
      )}
    </div>
  );
};

export default FabricationTab;
